<template>
  <b-container fluid>
    <!-- <h2>User Prefrences</h2> -->

    <b-modal
      title="User Prefrences"
      v-model="showModal"
      size="lg"
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <b-overlay :show="onSubmitting">
        <div class="text-left">
          <b-form-group label="Select Individual">
            <multiselect
              v-model="selectedIndividual"
              label="text"
              track-by="text"
              :clearable="true"
              :multiple="true"
              :options="individualOptions"
              placeholder="Select Individual"
              @input="individualIssue = false"
            ></multiselect>
            <p v-if="individualIssue" style="color: #dc3545; font-size: 80%">
              Please select department or any individual.
            </p>
          </b-form-group>
          <b-form-group>
            <div class="m-2 ml-0" style="align-items: center">
              Select Access :
              <div style="display: flex; flex-wrap: wrap">
                <div v-for="(form, index) in formsName" :key="index">
                  <b-badge
                    class="ml-1"
                    v-if="formsName.length"
                    variant="success"
                    >{{ form.title }}</b-badge
                  >
                </div>
              </div>
            </div>

            <vue-good-table
              @on-selected-rows-change="selectMultipleForms"
              ref="groupedTable"
              :columns="tablecolumns"
              :rows="groupTableRows"
              :select-options="{ enabled: true }"
              :search-options="{ enabled: true }"
              :group-options="{
                enabled: true,
              }"
            >
            </vue-good-table>
          </b-form-group>
        </div>
      </b-overlay>
      <template v-slot:modal-footer>
        <b-button
          :disabled="onSubmitting"
          variant="outline-success"
          class="mr-3"
          @click="resetForms"
          >Cancel</b-button
        >
        <b-button
          v-b-tooltip.hover
          :title="
            selectedIndividual.length == 0 ? 'Please Select a Individual' : ''
          "
          :disabled="selectedIndividual.length == 0 || onSubmitting"
          variant="outline-danger"
          @click="onSubmitForm()"
          >Save</b-button
        >
      </template>
    </b-modal>
    <b-card no-body class="shadow-sm pt-0 pl-0 pr-0 m-4 mb-0" style="margin-left: 15% !important;">
      <b-navbar class="background-white" toggleable="lg">
        <b-navbar-brand href="#">
          <strong style="color: #3b3e66">User Prefrences</strong>
        </b-navbar-brand>
        <b-navbar-nav class="ml-auto">
          <b-nav-form>
            <b-button
              @click="openModal"
              class="mr-2"
              variant="outline-primary"
              size="sm"
            >
              Edit User Prefrences
            </b-button>
            <b-button
              variant="outline-info"
              size="sm"
              class="mr-2"
              @click="reloadTable"
            >
              Reload
            </b-button>
            <b-form onSubmit="return false;">
              <b-input-group size="sm">
                <b-form-input
                  type="search"
                  @input="onEmpltyFilter($event)"
                  v-model="filter"
                  @keyup.enter="submitSearch"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    :disabled="!filter"
                    variant="outline-success"
                    @click="submitSearch"
                    >Search</b-button
                  >
                  <b-button :disabled="!filter" @click="setFIlterClear"
                    >Clear</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </b-form>
          </b-nav-form>
        </b-navbar-nav>
      </b-navbar>
      <b-overlay :show="isLoading">
        <b-table
          class="main-table"
          hover
          striped
          sticky-header="calc(100vh - 295px)"
          ref="table"
          id="governance-data-table"
          :busy.sync="isLoading"
          :fields="staticFields"
          :items="tableDataItems"
          :filter="filterTable ? filter : null"
          :per-page="perPage"
          :current-page="currentPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          select-mode="single"
          no-sort-reset
        >
          <template v-slot:cell(manage_emp)="data">
            <div v-if="data.item.manage_emp == '1'">
              <font-awesome-icon size="lg" icon="check-circle" />
            </div>
            <div v-else>
              <font-awesome-icon size="lg" icon="times-circle" />
            </div>
          </template>
          <template v-slot:cell(health_safety)="data">
            <div v-if="data.item.health_safety == '1'">
              <font-awesome-icon size="lg" icon="check-circle" />
            </div>
            <div v-else>
              <font-awesome-icon size="lg" icon="times-circle" />
            </div>
          </template>
          <template v-slot:cell(aproval_list)="data">
            <div v-if="data.item.aproval_list == '1'">
              <font-awesome-icon size="lg" icon="check-circle" />
            </div>
            <div v-else>
              <font-awesome-icon size="lg" icon="times-circle" />
            </div>
          </template>
          <template v-slot:cell(complaints)="data">
            <div v-if="data.item.complaints == '1'">
              <font-awesome-icon size="lg" icon="check-circle" />
            </div>
            <div v-else>
              <font-awesome-icon size="lg" icon="times-circle" />
            </div>
          </template>
          <!-- selectable -->
          <!-- @row-selected="onSelectRow" -->
        </b-table>
      </b-overlay>
      <template v-slot:footer>
        <b-row>
          <b-col cols="2">
            <b-form-select
              v-model="perPage"
              id="perPageSelect"
              size="sm"
              :options="pageOptions"
            ></b-form-select>
          </b-col>
          <b-col cols="6">
            <p class="text-center">
              Displaying Result From
              <b>{{ fromRows }}</b> to
              <b>{{ toRows }}</b>
            </p>
          </b-col>
          <b-col cols="4">
            <b-pagination
              class="float-right"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              aria-controls="governance-data-table"
            ></b-pagination>
          </b-col>
        </b-row>
      </template>
    </b-card>
  </b-container>
</template>

<script>
import { HTTP } from "../../../utils/HTTP";
import { Helper } from "../../../helpers";

export default {
  name: "UserPrefrences",
  data() {
    return {
      showModal: false,
      isFormsLoading: false,
      departmentOptions: [],
      individualOptions: [],
      selectedDepartment: [],
      selectedIndividual: [],
      individualIssue: false,
      formsName: [],
      onSubmitting: false,
      tablecolumns: [{ field: "title", label: "Select All", sortable: false }],
      groupTableRows: [
        {
          mode: "span",
          label: "",
          html: false,
          children: [
            {
              title: "Manage Employee",
              icon: "fa fa-users",
              href: "/goverance/one",
              hidden: false,
            },
            {
              title: "Heath And Safety",
              icon: "fa fa-exclamation",
              href: "/goverance/health_and_safety",
              hidden: false,
            },
            // {
            //   title: "Tasks",
            //   icon: "fa fa-thumbtack",
            //   href: "/tasks",
            //   hidden: true,
            // },
            {
              title: "Approval List",
              icon: "fa fa-gift",
              href: "/employee-approval-list",
              hidden: false,
            },
            {
              title: "Complaints",
              icon: "fa fa-balance-scale",
              href: "/complaints-dashboard",
              hidden: false,
            },
          ],
        },
      ],
      isLoading: false,
      staticFields: [
        { key: "first_name", label: "First Name", sortable: true },
        { key: "last_name", label: "Last Name", sortable: true },
        { key: "department", label: "Division Unit", sortable: true },
        { key: "country", label: "Country", sortable: true },
        { key: "manage_emp", label: "Manage Employee", sortable: true },
        { key: "health_safety", label: "Heath And Safety", sortable: true },
        { key: "aproval_list", label: "Approval List", sortable: true },
        { key: "complaints", label: "Complaints", sortable: true },
      ],
      accessRights: [],
      filterTable: false,
      totalRows: 0,
      fromRows: 0,
      toRows: 0,
      filter: null,
      perPage: 10,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      tableDataItems: [],
    };
  },
  mounted() {
    this.getIndividuals();
    this.getUserPrefrenceTableData();
  },
  computed: {
    rows() {
      return this.totalRows;
    },
  },
  methods: {
    openModal() {
      this.showModal = true;
    },
    async getIndividuals() {
      this.isFormsLoading = true;
      this.individualOptions = [];
      try {
        let result = await HTTP(
          "post",
          "api/v1/employees/get-employee-list/admin/active",
          null
        );

        this.individualOptions = result.data;
        // console.log(this.individualOptions, "individualOptions");
        this.isFormsLoading = false;
      } catch (error) {
        this.isFormsLoading = false;
      }
    },
    selectMultipleForms(value) {
      //   let filterValue = value.selectedRows.map(
      //     ({ originalIndex, vgtSelected, vgt_id, ...item }) => item
      //   );
      //   this.formsName = [];
      //   if (filterValue.length > 0) {
      //     this.formIssue = false;
      //     filterValue.map((data) => {
      //       this.formsName.push(data);
      //     });
      //   } else {
      //     let formIndex = this.formsName.findIndex((x) => x == filterValue.id);
      //     this.formsName.splice(formIndex, 1);
      //   }
      this.formsName = [];
      if (value.selectedRows.length > 0) {
        this.formIssue = false;
        value.selectedRows.map((data) => {
          this.formsName.push(data);
        });
      } else {
        let formIndex = this.formsName.findIndex((x) => x == value.id);
        this.formsName.splice(formIndex, 1);
      }
    },
    resetForms() {
      this.showModal = false;
      this.formsName = [];
      this.selectedIndividual = [];
    },
    async onSubmitForm() {
      this.onSubmitting = true;
      let selectedEmployeeIds = this.selectedIndividual.map((x) => x.value);
      let formData = {
        user_id: localStorage.getItem("userId"),
        employee_ids: selectedEmployeeIds,
        access_rights: this.formsName,
      };
      try {
        let result = await HTTP(
          "post",
          "api/v1/employees/update/access/rights",
          formData
        );
        if (result.data) {
          if (result.data && result.data.status == 1) {
            this.onSubmitting = false;
            this.accessRights = [];
            this.resetForms();
            this.reloadTable();

            Helper.makeToast(
              this.$bvToast,
              "success",
              "User Prefrences saved successfully"
            );
          }
        }
        // this.individualOptions = result.data;
      } catch (error) {
        return [error];
      }
    },
    reloadTable() {
      this.getUserPrefrenceTableData();
      // this.$root.$emit("bv::refresh::table", "governance-data-table");
    },
    async getUserPrefrenceTableData() {
      this.tableDataItems = [];
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
        per_page: this.perPage,
        page: this.currentPage,
      };
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      try {
        const response = await HTTP(
          "post",
          "api/v1/governance/training/admin/data",
          formData,
          {
            Authorization: token,
          }
        );
        response.data.data.map((item) => {
          if (item.access_rights != null) {
            this.accessRights.push(item.access_rights);
          } else {
            this.accessRights.push("0");
          }
        });
        // console.log(this.accessRights, "access_rights");
        this.filterTable = false;
        this.totalRows = response.data.total;
        this.fromRows = response.data.from;
        this.toRows = response.data.to;
        this.tableDataItems = response.data.data;
        this.addDynamicAccessRights();
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
        return [err];
      }
    },
    addDynamicAccessRights() {
      this.accessRights.map((item, index) => {
        if (item == "0") {
          this.tableDataItems[index].manage_emp = "0";
          this.tableDataItems[index].health_safety = "0";
          this.tableDataItems[index].aproval_list = "0";
          this.tableDataItems[index].complaints = "0";
        } else {
          let parsedData = JSON.parse(item);
          parsedData.map((data) => {
            if (data.title == "Manage Employee") {
              this.tableDataItems[index].manage_emp = "1";
            } else if (data.title == "Heath And Safety") {
              this.tableDataItems[index].health_safety = "1";
            } else if (data.title == "Approval List") {
              this.tableDataItems[index].aproval_list = "1";
            } else if (data.title == "Complaints") {
              this.tableDataItems[index].complaints = "1";
            }
          });
        }
      });
      // console.log(this.tableDataItems,"tableDataItems")
    },
    submitSearch() {
      if (this.filter) {
        this.filterTable = true;
      }
    },
    onEmpltyFilter(value) {
      if (value) {
        return;
      } else {
        this.setFIlterClear();
      }
    },
    setFIlterClear() {
      this.filter = "";
      this.filterTable = false;
      this.reloadTable();
    },
  },
};
</script>

<style>
</style>